import {
    BodyMediumRegular,
    Button,
    ButtonVariant,
    Sheet,
    YStack,
} from 'smoothie';

interface SessionSheetProps {
    isOpen: boolean;
    onClose: () => void;
}

export const CompletedSessionSheet = ({
    isOpen,
    onClose,
}: SessionSheetProps) => {
    const title = "You've already had this session";
    const message =
        'You can only book each session once. Check out what’s next up for you by scrolling to the right.';
    return (
        <Sheet
            title={title}
            isOpen={isOpen}
            onClose={onClose}
            showCloseButton={false}
            forceKeyboardCompatibleBottomSheet
        >
            <YStack paddingTop={12} gap={50} $sm={{ gap: 80 }}>
                <BodyMediumRegular>{message}</BodyMediumRegular>
                <Button
                    variant={ButtonVariant.PRIMARY}
                    text="Got it"
                    onPress={onClose}
                />
            </YStack>
        </Sheet>
    );
};

export const IneligibleSessionSheet = ({
    isOpen,
    onClose,
}: SessionSheetProps) => {
    const title = "You can't book this session yet";
    const message =
        "Don't worry, you'll get there! If there's something urgent you need to discuss with your Guide, you can always send them a message.";
    return (
        <Sheet
            title={title}
            isOpen={isOpen}
            onClose={onClose}
            showCloseButton={false}
            forceKeyboardCompatibleBottomSheet
        >
            <YStack paddingTop={12} gap={50} $sm={{ gap: 80 }}>
                <BodyMediumRegular>{message}</BodyMediumRegular>
                <Button
                    variant={ButtonVariant.PRIMARY}
                    text="Got it"
                    onPress={onClose}
                />
            </YStack>
        </Sheet>
    );
};
